<template>
  <div class="container">
    <iain-image-domain h="216" r="10" :src="cover" />
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    cover: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 0 30px 15px;
  background-color: rgba(248, 248, 248, 1);

  .title {
    padding-top: 15px;
    font-size: 26px;
    line-height: 38px;
    font-weight: bold;
    color: #222222;
    overflow: hidden;
  }
}
</style>